import script from "./Fullpage.vue?vue&type=script&lang=ts"
export * from "./Fullpage.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__